interface FeatureItemProps {
  icon: JSX.Element;
  text: string;
}

const DestinationFeatureItem: React.FC<FeatureItemProps> = ({ icon, text }) => {
  return (
    <div className="flex flex-row items-center mb-4">
      <div className="w-1 h-8 mr-3 bg-grey-a7 rounded-full" />
      <div className="w-6 h-6 mr-3">{icon}</div>
      <div className="flex-1">
        <p className="text-gray-700 text-base leading-relaxed">{text}</p>
      </div>
    </div>
  );
};

export default DestinationFeatureItem;
